import { Button } from '@/components/ui/button'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card'
import { PresenceViewer } from 'app/frontend/base/hooks/usePresenceChannel'
import {
  getViewerColorClass,
  getViewerInitials,
} from 'app/frontend/base/pages/TeamDashboard/subpages/TeamPlans/components/viewerPresence'

interface Props {
  viewers: PresenceViewer[]
}

const ViewerPresenceButton = ({ viewers }: Props) => {
  if (viewers.length <= 1) {
    return (
      <Button variant='outline' size='sm' disabled>
        {viewers.length} viewer{viewers.length === 1 ? '' : 's'}
      </Button>
    )
  }

  return (
    <HoverCard openDelay={100} closeDelay={100}>
      <HoverCardTrigger asChild>
        <Button variant='outline' size='sm'>
          {viewers.length} viewer{viewers.length === 1 ? '' : 's'}
        </Button>
      </HoverCardTrigger>
      <HoverCardContent align='end' className='w-fit p-2'>
        <div className='space-y-2'>
          {viewers.map((viewer, viewerIndex) => (
            <div key={viewer.key} className='flex items-center gap-2'>
              <div
                className={`h-7 w-7 rounded-full text-xs font-semibold cursor-default text-white flex items-center justify-center ${getViewerColorClass(
                  viewerIndex,
                )}`}
              >
                {getViewerInitials(viewer.label)}
              </div>
              <span className='text-xs truncate'>{viewer.label}</span>
            </div>
          ))}
        </div>
      </HoverCardContent>
    </HoverCard>
  )
}

export default ViewerPresenceButton
